<template>
  <span>
    <span v-if="!isDeviceIosOrUnableToLunchAR">
      <a v-if="isKGVisualization!=true"
        :href="'memex://request?language='+getPreferredLanguage+'&tags='+getTags+'&textFilterStory='+getSearchBarTextValue+'&textFilterJourney='+getSearchBarTextValueJourney+'&jwt='+jwt">
        <v-icon>mdi-cube-outline</v-icon>
      </a>
      <a v-else style="border:2px solid;border-radius:99rem;height: 36px;min-width: 64px;padding: 6px 16px;"
        color=primary
        :href="'memex://request?language='+getPreferredLanguage+'&tags='+getTags+'&textFilterStory='+getSearchBarTextValue+'&textFilterJourney='+getSearchBarTextValueJourney+'&jwt='+jwt">{{$t('viewIn')}}
        <v-icon color=primary>mdi-cube-outline</v-icon></a>
    </span>
    <span v-else @click="deeplinkNotReady()">
      <v-icon>mdi-cube-outline</v-icon>
    </span>
  </span>
</template>

<script>
    export default {
  name: 'deepLinkButton',

  components: {

  },

  data () {
  return {
      }
  },
  mounted(){
  },
    props: {
    isKGVisualization: {
      type: Boolean,
      required: false
    },

  },
  computed: {
            getPreferredLanguage: {
            get: function () {
                return this.$store.getters.getPreferredLanguage;
            }},
    getSearchBarTextValueJourney:{
      get: function () {
        return this.$store.getters.getSearchBarTextValueJourney
      },
      set: function () {
      }
    },
    getSearchBarTextValue:{
      get: function () {
        return this.$store.getters.getSearchBarTextValue
      }
    },
    getTags: {
      get: function () {
        return this.$store.getters.getListOfSelectedTag
      }
    },
    isDeviceIosOrUnableToLunchAR: {
      get: function () {
        if(this.$device.ios)
        return true
        return false
      }
    },
    drawer: {
      get: function () {
        return this.$store.getters.getIsdrawerOpen;
      },
      set: function () {
      }
    },
    jwt: {
      get: function () {
        return this.$store.getters.getAccessToken;
      }
    },
    getUser: {
      get: function () {
        return this.$store.getters.getUser;
      }
    },
    getcurrenUserStoryFilter: {
      get: function () {
        return this.$store.getters.getcurrenUserStoryFilter;
      }
    },
  },

methods: {
deeplinkNotReady:function (){

alert("This device is not android or does not have the AR application installed " + JSON.stringify(this.$device))

},
    gotopage: function (page,params) {
        if (page=='createNewStoryContent'){
          //reset new stories and push
        const defaultCache={isStoryID:null,checkboxPublic:false,storyTitle:"",content:"", imageFileRaw:null,imageFile:null,imageType:"image/jpeg",audioFiles:[],audioFilesRaw:[],audioTypes:[],audioFileTitles:[],videoFileRaw:null,videoFile:null,videoType:"video/mp4"}
        this.$store.dispatch("setNewStories", defaultCache).then(()=>{
          if(this.$router.currentRoute.name!=page)
            this.$router.push({'name':page,'params':params})
        })

        }
        else {
          if(this.$router.currentRoute.name!=page){
            this.$router.push({'name':page,'params':params})
          }
        }
    },
}
}
</script>
<style >

</style>